import React from "react";

import { Button } from "@/atoms/button/Button";
import { Modal } from "@/atoms/modal/Modal";

import { PersonalisationHeading } from "./PersonalisationHeading";

type ConfirmLeaveModalProps = {
  readonly open: boolean;
  readonly onContinue: () => void;
  readonly onLeave: () => void;
};

export const ConfirmLeaveModal = ({
  open,
  onContinue,
  onLeave,
}: ConfirmLeaveModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onContinue}
      headerClassName="px-8 pt-8"
      bodyClassName="px-8"
      footer={
        <div className="flex flex-col gap-4 p-8">
          <Button style="primary" size="large" fullWidth onClick={onContinue}>
            Continue
          </Button>
          <Button style="secondary" size="large" fullWidth onClick={onLeave}>
            I&apos;ll do this later
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-9">
        <div className="flex flex-col gap-9">
          <PersonalisationHeading size="sm">
            Are you sure you want to leave?
          </PersonalisationHeading>
          <div className="flex flex-col gap-9 text-[#6B7070]">
            <p className="text-sm font-normal leading-[18px] text-[#6B7070]">
              Sharing a few quick details helps unlock recommendations designed
              exclusively for you.
            </p>
            <p className="text-sm font-normal leading-[18px] text-[#6B7070]">
              This will take less than a minute.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};
